import axios from 'axios'

const API_BASE_URL = '/'

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器：自动携带token
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = token
  }
  return config
}, error => Promise.reject(error))

// 响应拦截器：处理错误响应
api.interceptors.response.use(
  response => response,
  error => {
    // 无论状态码如何，都尝试返回响应数据，让调用者处理
    if (error.response) {
      return Promise.reject(error)
    }
    return Promise.reject(error)
  }
)

export const authAPI = {
  // 登录接口
  login(username, password) {
    return api.post('/user/login', {
      username,
      password
    })
  },
  
  // 注册接口
  register(username, password, nickname) {
    return api.post('/user/register', {
      username,
      password,
      nickname
    })
  }
}

export default api